import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  forwardRef,
  HostListener,
  Input,
  Renderer2,
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { GasInputBoolean } from '@cikrf/gas-utils/decorators';
import { GasIcon } from '../../../utils/gas-icons/icon/gas-icon.namespace';
import { GasFormBaseComponent } from '../../gas-form-base-component';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

/** @see https://www.figma.com/file/WUetK5yDgXs9HeTZmhcIt1/Components%3A-Web-%7C-Lightning-Design-System-(Community)?node-id=764%3A7 */
@UntilDestroy()
@Component({
  selector: 'gas-checkbox',
  templateUrl: './gas-checkbox.component.html',
  styleUrls: ['./gas-checkbox.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => GasCheckboxComponent),
      multi: true,
    },
  ],
})
export class GasCheckboxComponent extends GasFormBaseComponent {
  @GasInputBoolean()
  @Input()
  public set checked(isChecked: string | boolean) {
    this.checkedSubject$.next(isChecked as boolean);
  }

  public get checked(): string | boolean {
    return this.checkedSubject$.getValue();
  }

  @GasInputBoolean()
  @Input()
  public value: string | boolean = false;

  @GasInputBoolean()
  @Input()
  public indeterminate: string | boolean = false;

  @GasInputBoolean()
  @Input()
  public visibleChanges: string | boolean = false;

  @Input()
  public description: string;

  @Input()
  public modified = true;

  public iconName = GasIcon.Core.CellChecked;

  public checked$: Observable<boolean>;

  private checkedSubject$ = new BehaviorSubject<boolean>(false);

  // public модификаторы свойств конструктора добавлены т.к. свойства используются в других компонентах
  constructor(
    public elementRef: ElementRef,
    public changeDetectorRef: ChangeDetectorRef,
    public renderer: Renderer2,
  ) {
    super(changeDetectorRef, elementRef, renderer);
    this.checked$ = this.checkedSubject$.asObservable()
      .pipe(
        tap((isChecked: boolean) => {
          this.onChange(isChecked);
        }),
      );
    this.form.valueChanges
      .pipe(
        untilDestroyed(this),
      )
      .subscribe((value: boolean) => {
        this.checkedSubject$.next(Boolean(value));
      });
  }

  @HostListener('click')
  public handleClick(): void {
    this.form.setValue(!this.checkedSubject$.getValue());
  }

  public get isModified(): boolean {
    return this.visibleChanges
      && this.classPrimary
      && this.modified;
  }

  public writeValue(isChecked: boolean): void {
    this.checked = isChecked;
  }

}
